<template>
    <ActivityDetailsCard
        activityType="Pledged Shares"
        :title="item.description"
        :entity="item.entity"
        class="pledged-shares-activity-details"
    >
        <template #sub-header>
            <div class="cell wide">
                <h5>Company</h5>
                <span>{{ company.name }}</span>
            </div>
            <div class="cell wide">
                <h5>Date</h5>
                <span>{{ date }}</span>
            </div>
            <div class="cell">
                <h5>Pledged of Owned</h5>
                <span>{{ formats.percent(pledgedOfOwned) }}</span>
            </div>
            <div class="cell">
                <h5>Pledged of Outstanding</h5>
                <span>{{ formats.percent(pledgedOfOutstanding) }}</span>
            </div>
        </template>

        <CompanyPledgedShares :pledgedShares="pledgedSecurities" :highlight="pledgedSecurity" class="profile-section" />

        <ActivityStockPriceLine :item="item" />
    </ActivityDetailsCard>
</template>

<script>
import ActivityStockPriceLine from '@/components/activity/ActivityStockPriceLine'
import ActivityDetailsCard from '@/components/activity/ActivityDetailsCard.vue'
import CompanyPledgedShares from '@/components/PledgedShares/CompanyPledgedShares.vue'

import { formatNegativeParens } from '@/utils/format'

export default {
    components: {
        ActivityDetailsCard,
        ActivityStockPriceLine,
        CompanyPledgedShares,
    },
    data() {
        return {
            formats: {
                percent(value) {
                    if (value === undefined || value === null) {
                        return 'N/A'
                    }

                    return formatNegativeParens(value, { style: 'percent', maximumFractionDigits: 1 })
                },
            },
        }
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        company() {
            return this.details.company
        },
        date() {
            return new Date(this.pledgedSecurity.effectiveDate).toLocaleDateString()
        },
        details() {
            return this.item.details
        },
        id() {
            return this.details.id
        },
        pledgedOfOwned() {
            return this.pledgedSecurity.totalPledgedShares === 0
                ? 0
                : this.pledgedSecurity.totalPledgedShares / this.pledgedSecurity.totalSharesBeneficiallyOwned
        },
        pledgedOfOutstanding() {
            return this.pledgedSecurity.totalPledgedShares === 0
                ? 0
                : this.pledgedSecurity.totalSharesOutstanding
                ? this.pledgedSecurity.totalPledgedShares / this.pledgedSecurity.totalSharesOutstanding
                : NaN
        },
        pledgedSecurity() {
            return this.details.pledgedSecurities.find(ps => ps.id === this.id)
        },
        pledgedSecurities() {
            return this.details.pledgedSecurities
        },
    },
}
</script>
<style>
.pledged-shares-activity-details {
    .profile-section + .profile-section {
        margin-top: 40px;
    }
}
</style>
